import { showToast, showSuccessToast, showFailToast, showLoadingToast, closeToast } from "vant";

// 自定义 Toast 方法封装
const customToast = {
  /**
   * 通用 Toast
   */
  show(message, options = {}) {
    showToast({
      message,
      wordBreak: "break-word", // 默认设置为 break-word
      ...options,
    });
  },

  /**
   * 成功提示
   */
  success(message, options = {}) {
    showSuccessToast({
      message,
      wordBreak: "break-word", // 默认设置为 break-word
      ...options,
    });
  },

  /**
   * 失败提示
   */
  fail(message, options = {}) {
    showFailToast({
      message,
      wordBreak: "break-word", // 默认设置为 break-word
      ...options,
    });
  },

  /**
   * 加载中提示
   */
  loading(message, options = {}) {
    showLoadingToast({
      message,
      wordBreak: "break-word", // 默认设置为 break-word
      forbidClick: true, // 禁止点击
      ...options,
    });
  },

  /**
   * 清除所有 Toast
   */
  clear() {
    closeToast();
  },
};

export default customToast;
